import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { FaPlane, FaGraduationCap, FaPassport, FaBriefcase, FaMapMarkerAlt } from 'react-icons/fa';
import '../styles/ServicesSection.css';

const ServicesSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  
  const services = [
    {
      id: 1,
      icon: <FaPlane />,
      title: 'Billetterie & Voyages organisés',
      description: 'Réservation de billets d\'avion, organisation de voyages sur mesure, circuits touristiques et séjours tout compris.'
    },
    {
      id: 2,
      icon: <FaGraduationCap />,
      title: 'Études à l\'étranger',
      description: 'Accompagnement complet pour les études au Canada, France, Roumanie, Belgique et autres destinations.'
    },
    {
      id: 3,
      icon: <FaPassport />,
      title: 'Démarches touristiques & Visa',
      description: 'Assistance pour l\'obtention de visas touristiques, d\'affaires ou d\'études pour tous pays.'
    },
    {
      id: 4,
      icon: <FaBriefcase />,
      title: 'Contrats de travail',
      description: 'Accompagnement pour l\'obtention de contrats de travail au Canada, France, Allemagne et autres pays.'
    },
    {
      id: 5,
      icon: <FaMapMarkerAlt />,
      title: 'Immigration Canada',
      description: 'Services complets pour l\'immigration au Canada: Entrée Express, Programme des candidats des provinces, regroupement familial et autres programmes.'
    }
  ];
  
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.5
      }
    })
  };
  
  return (
    <section id="services" className="section services-section">
      <div className="container">
        <h2 className="section-title">Nos Services</h2>
        
        <div className="services-grid" ref={ref}>
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className="service-card"
              custom={index}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              variants={cardVariants}
              whileHover={{ 
                scale: 1.05,
                boxShadow: '0 20px 30px rgba(0, 0, 0, 0.1)'
              }}
            >
              <div className="service-icon">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <div className="service-hover-content">
                <span>En savoir plus</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection; 